import { useTranslation } from 'react-i18next';
import { mdiClose } from '@mdi/js';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import { IconButton } from 'common/components/IconButton';
import { getScormUrl } from 'training/utils/scorm';

interface IProps {
    open: boolean;
    scormId: string;
    title?: string;
    onClose(): void;
}

export const ScormPreviewModal = ({
    open,
    scormId,
    title,
    onClose,
}: IProps) => {
    const [translate] = useTranslation();

    const heading = title || translate('preview');

    return (
        <Dialog
            fullWidth
            aria-labelledby="scorm-preview-title"
            maxWidth="lg"
            open={open}
            slotProps={{
                paper: {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '90vh',
                    },
                },
            }}
            onClose={onClose}
        >
            <DialogTitle
                id="scorm-preview-title"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Box
                    component="span"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {heading}
                </Box>

                <IconButton
                    aria-label={translate('close')}
                    edge="end"
                    iconPath={mdiClose}
                    iconSize="2.4rem"
                    onClick={onClose}
                />
            </DialogTitle>

            <Box sx={{ flex: 1, minHeight: 0 }}>
                {open && (
                    <iframe
                        src={getScormUrl(scormId, { preview: true })}
                        style={{
                            border: 'none',
                            display: 'block',
                            height: '100%',
                            width: '100%',
                        }}
                        title={heading}
                    />
                )}
            </Box>
        </Dialog>
    );
};
